module.exports = __webpack_public_path__ + "img/ic_share.1909a1f4.svg";